var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBranches(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 512,
    viewBox: "0 0 60 53",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#5e5e5e",
    id: "026---Tree-Branch-UI",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m58 41v-36c-.0033061-2.76005315-2.2399468-4.99669388-5-5h-46c-2.76005315.00330612-4.99669388 2.23994685-5 5v36c-1.1045695 0-2 .8954305-2 2v3c.00440864 3.8641657 3.13583434 6.9955914 7 7h46c3.8641657-.0044086 6.9955914-3.1358343 7-7v-3c0-1.1045695-.8954305-2-2-2zm-54-36c0-1.65685425 1.34314575-3 3-3h46c1.6568542 0 3 1.34314575 3 3v36h-52zm17 38h18v1c0 1.1045695-.8954305 2-2 2h-14c-1.1045695 0-2-.8954305-2-2zm37 3c-.0033061 2.7600532-2.2399468 4.9966939-5 5h-46c-2.76005315-.0033061-4.99669388-2.2399468-5-5v-3h17v1c0 2.209139 1.790861 4 4 4h14c2.209139 0 4-1.790861 4-4v-1h17z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m15 45h-3c-.5522847 0-1 .4477153-1 1s.4477153 1 1 1h3c.5522847 0 1-.4477153 1-1s-.4477153-1-1-1z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 6,
    cy: 46,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 9,
    cy: 46,
    r: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m21 34v-6c0-1.6568542-1.3431458-3-3-3h-3v-2c0-.5522847.4477153-1 1-1h13v3h-3c-1.6568542 0-3 1.3431458-3 3v6c0 1.6568542 1.3431458 3 3 3h8c1.6568542 0 3-1.3431458 3-3v-6c0-1.6568542-1.3431458-3-3-3h-3v-3h13c.5522847 0 1 .4477153 1 1v2h-3c-1.6568542 0-3 1.3431458-3 3v6c0 1.6568542 1.3431458 3 3 3h8c1.6568542 0 3-1.3431458 3-3v-6c0-1.6568542-1.3431458-3-3-3h-3v-2c0-1.6568542-1.3431458-3-3-3h-13v-2h7c1.6568542 0 3-1.3431458 3-3v-6c0-1.65685425-1.3431458-3-3-3h-16c-1.6568542 0-3 1.34314575-3 3v6c0 1.6568542 1.3431458 3 3 3h7v2h-13c-1.6568542 0-3 1.3431458-3 3v2h-3c-1.65685425 0-3 1.3431458-3 3v6c0 1.6568542 1.34314575 3 3 3h8c1.6568542 0 3-1.3431458 3-3zm30-6v6c0 .5522847-.4477153 1-1 1h-8c-.5522847 0-1-.4477153-1-1v-6c0-.5522847.4477153-1 1-1h8c.5522847 0 1 .4477153 1 1zm-16 0v6c0 .5522847-.4477153 1-1 1h-8c-.5522847 0-1-.4477153-1-1v-6c0-.5522847.4477153-1 1-1h8c.5522847 0 1 .4477153 1 1zm-14-13v-6c0-.55228475.4477153-1 1-1h16c.5522847 0 1 .44771525 1 1v6c0 .5522847-.4477153 1-1 1h-16c-.5522847 0-1-.4477153-1-1zm-2 19c0 .5522847-.4477153 1-1 1h-8c-.55228475 0-1-.4477153-1-1v-6c0-.5522847.44771525-1 1-1h8c.5522847 0 1 .4477153 1 1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m26 11h-2c-.5522847 0-1 .4477153-1 1s.4477153 1 1 1h2c.5522847 0 1-.4477153 1-1s-.4477153-1-1-1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m34 13h2c.5522847 0 1-.4477153 1-1s-.4477153-1-1-1h-2c-.5522847 0-1 .4477153-1 1s.4477153 1 1 1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m32 12c0-.5522847-.4477153-1-1-1h-2c-.5522847 0-1 .4477153-1 1s.4477153 1 1 1h2c.5522847 0 1-.4477153 1-1z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 12,
    cy: 31,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 16,
    cy: 31,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 28,
    cy: 31,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 32,
    cy: 31,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 44,
    cy: 31,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 48,
    cy: 31,
    r: 1
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBranches);
export default __webpack_public_path__ + "static/media/branches.cfa3a98e232094afc879e712a1bb76af.svg";
export { ForwardRef as ReactComponent };